<div v-show="active">
  <slot></slot>
</div>
